import Layout from '../../../components/Layout/Auth';
import Content from '../../../components/Pages/Auth/EmailVerification';
import { displayName } from '../../../config';
import Wrapper from '../../../components/Pages/Auth';

const EmailVerification = (): JSX.Element => {
  document.title = `${displayName}: Email Verification`;

  return (
    <Layout>
      <Wrapper>
        <Content />
      </Wrapper>
    </Layout>
  );
};

export default EmailVerification;
